/* eslint-disable prettier/prettier */
/* eslint-disable no-use-before-define */
import { useState, useEffect, useRef, Suspense, useCallback, useContext } from "react";
import { useDebouncedCallback } from "use-debounce";
import { useNavigate } from "react-router-dom";
import { trackPromise } from "react-promise-tracker";

import {
	TextField,
	Checkbox,
	Paper,
	Grid,
	Button,
	Select,
	MenuItem,
	Tooltip,
	InputAdornment,
	IconButton,
	CheckboxProps
} from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import "date-fns";
import { SnackbarProps } from "../../../@types/snackbarAPI.types";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";

import EventIcon from "@material-ui/icons/Event";
import ClearIcon from "@material-ui/icons/Clear";
import SendIcon from "@material-ui/icons/Send";
import InfoIcon from "@material-ui/icons/Info";

import "../../../globalStyles/paperFormStyles.css";
import { withStyles, Theme } from "@material-ui/core/styles";
import { PLAN_NAME, PLAN_STATUS } from "../../../constants/plan";
import { infoTitleMessage } from "../../../constants/infoTitleMessage";
import {
	GROUP_PLAN_NAMES,
	PANHANDLE_FIRST_BANK_CORE_PLAN_NAMES,
	PLAN_NAMES,
	PROGRESSIVE_LABORATORIES_PLAN_NAMES
} from "../../../constants/planNames";
import useRouteParam from "../../../hooks/useRouteParam";
import { GROUP_NUMBER } from "../../../constants/groups";
import { PlanStatus } from "../../../@types/plan.types";
import { api } from "../../../utils/api";
import { normalizeDateForSetValue } from "../../../utils/commonFunctions/date";

const date = new Date();
const maxDateRange = date.setDate(date.getDate());
const GreenCheckbox = withStyles({
	root: {
		color: green[400],
		marginLeft: "0.7rem",
		"&$checked": {
			color: green[600]
		}
	},
	checked: {}
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

const LightTooltip = withStyles((theme: Theme) => ({
	tooltip: {
		backgroundColor: "#f5f5f9",
		color: "rgba(0, 0, 0, 0.87)",
		boxShadow: theme.shadows[1],
		maxWidth: 130,
		fontSize: 11
	}
}))(Tooltip);

const DynamicReportEditableForm = ({
	reportDetailsDynamicForm,
	selectedPlanName,
	handleKeyCheck,
	handlePaste,
	handleClearDateField,
	validation,
	handleGenerateReportSubmit
}: any) => {
	const queryGroupNumber = useRouteParam("gn");
	let PLANS_TO_BE_SELECT: object = {};
	let groupNumber = queryGroupNumber;

	// if (queryGroupNumber) {
	// 	groupNumber = queryGroupNumber;
	// }

	//This code for super admin
	if (!queryGroupNumber && reportDetailsDynamicForm) {
		const reportDetailsDynamicFormKeyName = Object.keys(reportDetailsDynamicForm)[0];
		reportDetailsDynamicForm[reportDetailsDynamicFormKeyName].find((field: { name: string; value: string }) => {
			if (field.name === "group_number") {
				groupNumber = field.value;
			}
		});
	}

	switch (groupNumber) {
		case GROUP_NUMBER.BBI_BROOKSHIRE_BROTHERS: {
			PLANS_TO_BE_SELECT = GROUP_PLAN_NAMES;
			break;
		}

		case GROUP_NUMBER.PROGRESSIVE_LABORATORIES: {
			PLANS_TO_BE_SELECT = PROGRESSIVE_LABORATORIES_PLAN_NAMES;
			break;
		}

		case GROUP_NUMBER.PANHANDLE_FIRST_BANK: {
			PLANS_TO_BE_SELECT = PANHANDLE_FIRST_BANK_CORE_PLAN_NAMES;
			break;
		}

		default: {
			PLANS_TO_BE_SELECT = {};
		}
	}

	// console.log("reportDetailsDynamicForm", reportDetailsDynamicForm);

	return (
		<div className="dynamic-report-form-container" id="dynamic-report-form-container">
			<div className="pf-action-button-container" id="pf-action-button-container">
				<Button
					className="button-green"
					onClick={handleGenerateReportSubmit}
					variant="contained"
					style={{
						pointerEvents: "unset"
					}}
				>
					<span className="button-label-with-icon">Submit</span>
					<span>
						<SendIcon className="button-icon" />
					</span>
				</Button>
			</div>
			<Grid container spacing={1} className="pf-grid-container">
				{reportDetailsDynamicForm &&
					Object.entries(reportDetailsDynamicForm).map(([key, value], index) => {
						return (
							<div key={index}>
								<div className="pf-title">{key}</div>
								<Suspense fallback={<div />}>
									<Paper className="pf-paper-container" elevation={3} variant="outlined">
										{value instanceof Array
											? value.map((field, index) => {
													return (
														<Grid item key={index} xl={12} lg={12} md={12} sm={12} xs={12}>
															<Grid
																container
																spacing={1}
																className="pf-label"
																style={{
																	display:
																		selectedPlanName === PLAN_NAME.health_plan
																			? field.name === "alternative_report_name"
																				? "none"
																				: ""
																			: ""
																}}
															>
																<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
																	<div
																		className={
																			field.name === "alternative_report_name" ||
																			field.name === "with_dependent" ||
																			field.name === "location_number" ||
																			field.name === "end_date" ||
																			field.name === "date" ||
																			field.name === "is_migrated"
																				? "pf-label-text"
																				: "pf-label-text required"
																		}
																		id="pf-label-text"
																	>
																		{field.label}
																	</div>
																</Grid>
																<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
																	{field.type === "textfield" ? (
																		<TextField
																			className="text-field"
																			id={
																				field.name === "group_number"
																					? "disabled-input-text-field"
																					: "input-text-field"
																			}
																			name={field.name}
																			placeholder={field.placeholder}
																			value={field.value}
																			onChange={field.onChange}
																			onKeyDown={(
																				event: React.KeyboardEvent<HTMLDivElement>
																			) => handleKeyCheck(event)}
																			onPaste={(
																				event: React.ClipboardEvent<HTMLDivElement>
																			) => handlePaste(event)}
																			variant="outlined"
																			style={{
																				pointerEvents: "unset",
																				width: "340px",
																				borderRadius: 50
																			}}
																			helperText={
																				validation.reportFieldDetails[
																					field.name
																				]
																			}
																			disabled={
																				field.name === "group_number"
																					? true
																					: false
																			}
																			InputProps={{
																				endAdornment: (
																					<>
																						{field.name ===
																						"group_number" ? (
																							<InputAdornment position="end">
																								<LightTooltip
																									title={
																										field.name ===
																										"group_number"
																											? infoTitleMessage.group
																											: ""
																									}
																									placement="right-start"
																									arrow
																								>
																									<InfoIcon
																										style={{
																											color: "#808080",
																											fontSize:
																												"20px",
																											// cursor: !showSaveButton
																											// 	? "default"
																											// 	: "pointer",
																											pointerEvents:
																												"unset"
																										}}
																									/>
																								</LightTooltip>
																							</InputAdornment>
																						) : null}
																					</>
																				),
																				readOnly:
																					field.name === "group_number"
																						? true
																						: false
																			}}
																		/>
																	) : field.type === "select" ? (
																		<>
																			<Select
																				id="text-align-options"
																				name={field.name}
																				value={field.value}
																				onChange={field.onChange}
																				style={{
																					pointerEvents: "unset",
																					minWidth: 180,
																					textAlign: "left",
																					// zIndex: 10000,
																					overflowY: "visible"
																				}}
																				MenuProps={{
																					style: { zIndex: 35960 }
																				}}
																				inputProps={{
																					"aria-label": "Without label"
																				}}
																			>
																				<MenuItem value="" disabled>
																					Select Value
																				</MenuItem>
																				{field.name === "is_migrated" ? (
																					<MenuItem value="">
																						<em>None</em>
																					</MenuItem>
																				) : null}

																				{field.name === "group_number"
																					? field?.options?.map(
																							(
																								group: any,
																								index: number
																							) => {
																								const {
																									name,
																									group_number
																								} = group;
																								return (
																									<MenuItem
																										value={
																											group_number
																										}
																										key={index}
																									>
																										<span className="location-name-menu-item">{`${name} -`}</span>
																										<span className="location-number-menu-item">{`${group_number}`}</span>
																									</MenuItem>
																								);
																							}
																					  )
																					: field.name === "location_number"
																					? field?.options?.map(
																							(
																								location: any,
																								index: number
																							) => {
																								const {
																									location_name,
																									location_number
																								} = location;
																								return (
																									<MenuItem
																										value={
																											location_number
																										}
																										key={index}
																									>
																										<span className="location-name-menu-item">{`${location_name} -`}</span>
																										<span className="location-number-menu-item">{`${location_number}`}</span>
																									</MenuItem>
																								);
																							}
																					  )
																					: field.name === "plan_code"
																					? Object.entries(
																							PLANS_TO_BE_SELECT
																					  ).map(
																							(
																								[
																									plan_name,
																									planCaption
																								],
																								index: number
																							) => {
																								return (
																									<MenuItem
																										value={
																											planCaption
																										}
																										key={index}
																									>
																										<span className="location-name-menu-item">{`${planCaption}`}</span>
																									</MenuItem>
																								);
																							}
																					  )
																					: field.name === "agent_ids"
																					? field?.options?.map(
																							(
																								agent: any,
																								index: number
																							) => {
																								const {
																									_id,
																									first_name,
																									last_name
																								} = agent;

																								return (
																									<MenuItem
																										value={_id}
																										key={index}
																									>
																										<span className="location-name-menu-item">{`${first_name} ${last_name} `}</span>
																									</MenuItem>
																								);
																							}
																					  )
																					: field?.options?.map(
																							(option: any) => (
																								<MenuItem
																									key={option}
																									value={option}
																								>
																									{option}
																								</MenuItem>
																							)
																					  )}
																			</Select>
																			{validation &&
																			validation.reportFieldDetails[
																				field.name
																			] ? (
																				<div className="details">
																					<span className="select-validation-text2">
																						{
																							validation
																								.reportFieldDetails[
																								field.name
																							]
																						}
																					</span>
																				</div>
																			) : null}
																		</>
																	) : field.type === "date" ? (
																		<MuiPickersUtilsProvider utils={DateFnsUtils}>
																			<KeyboardDatePicker
																				className="from-date-input"
																				id="from-date-input"
																				inputVariant="outlined"
																				label={field.label}
																				placeholder={field.placeholder}
																				name={field.name}
																				format="MM/dd/yyyy"
																				error={false}
																				// value={field.value}
																				value={
																					field.value
																						? field.value
																							? normalizeDateForSetValue(
																									field.value
																							  )
																							: null
																						: field.value
																						? normalizeDateForSetValue(
																								field.value
																						  )
																						: null
																				}
																				onChange={(
																					date: MaterialUiPickersDate
																				) => field.onChange(date, field.name)}
																				maxDate={
																					field.name === "start_date"
																						? maxDateRange
																						: undefined
																				}
																				InputProps={{
																					startAdornment: (
																						<IconButton
																							// eslint-disable-next-line arrow-parens
																							onClick={(event) =>
																								handleClearDateField(
																									event,
																									field.name
																								)
																							}
																							style={{ order: 1 }}
																						>
																							<ClearIcon
																								color="disabled"
																								fontSize="small"
																							/>
																						</IconButton>
																					),
																					readOnly: true
																				}}
																				InputLabelProps={{
																					shrink: true
																				}}
																				//style={{ width: "340px", borderRadius: 50 }}
																				keyboardIcon={
																					<EventIcon
																						style={{
																							color: "#7cb342"
																						}}
																					/>
																				}
																				KeyboardButtonProps={{
																					"aria-label": "change date"
																				}}
																				// disabled={!isButtonSelected}
																				// disableElevation={!isButtonSelected}
																				style={{
																					// cursor: !isButtonSelected ? "not-allowed" : "pointer",
																					pointerEvents: "unset",
																					width: "340px",
																					borderRadius: 50
																				}}
																				helperText={
																					validation.reportFieldDetails[
																						field.name
																					]
																				}
																			/>
																		</MuiPickersUtilsProvider>
																	) : field.type === "checkbox" ? (
																		<>
																			<div
																				className="check-support"
																				id="check-support"
																			>
																				<span>
																					<GreenCheckbox
																						onChange={field.onChange}
																						name={field.name}
																						checked={field.value}
																					/>
																				</span>
																			</div>
																		</>
																	) : null}
																</Grid>
															</Grid>
														</Grid>
													);
											  })
											: null}
									</Paper>
								</Suspense>
							</div>
						);
					})}
			</Grid>
			{/* <div className="pf-action-button-container margin-top-action-button" id="pf-action-button-container">
				<Button
					className="button-green"
					onClick={handleGenerateReportSubmit}
					variant="contained"
					style={{
						pointerEvents: "unset"
					}}
				>
					<span className="button-label-with-icon">Submit</span>
					<span>
						<SendIcon className="button-icon" />
					</span>
				</Button>
			</div> */}
		</div>
	);
};

export default DynamicReportEditableForm;
